import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import {
  Home,
  LayoutGrid,
  Search,
  Sparkles,
  User,
} from 'lucide-react';
import { cn } from '@/lib/utils';

const TABS = [
  { id: 'home', label: 'Home', icon: Home, to: '/home' },
  { id: 'browse', label: 'Browse', icon: LayoutGrid, to: '/browse' },
  { id: 'search', label: 'Search', icon: Search, action: 'search' },
  { id: 'crowdfund', label: 'Fund', icon: Sparkles, to: '/crowdfund' },
  { id: 'you', label: 'You', icon: User, to: '/profile' },
];

const matchesActive = (pathname, to) => {
  if (to === '/home') return pathname === '/home' || pathname === '/';
  if (to === '/browse') return pathname.startsWith('/browse');
  if (to === '/profile') return pathname.startsWith('/profile') || pathname.startsWith('/watchlist') || pathname.startsWith('/history');
  return pathname.startsWith(to);
};

const MobileTabBar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-50 flex justify-around border-t border-border/30 bg-[hsl(var(--kinora-sidebar))] px-2 py-2 pb-[max(0.5rem,env(safe-area-inset-bottom))] lg:hidden"
      aria-label="Main navigation"
    >
      {TABS.map((tab) => {
        const Icon = tab.icon;
        const isActive =
          tab.action === 'search'
            ? false
            : matchesActive(location.pathname, tab.to);

        const handleClick = (e) => {
          if (tab.action === 'search') {
            e.preventDefault();
            navigate('/browse', { state: { focusSearch: true } });
          }
        };

        const className = cn(
          'flex min-w-0 flex-1 flex-col items-center gap-1 rounded-lg px-1 py-1.5 text-[10px] font-medium transition-colors',
          isActive ? 'text-primary' : 'text-muted-foreground'
        );

        if (tab.action === 'search') {
          return (
            <button
              key={tab.id}
              type="button"
              onClick={handleClick}
              className={className}
            >
              <Icon className="h-5 w-5" />
              <span>{tab.label}</span>
            </button>
          );
        }

        return (
          <Link key={tab.id} to={tab.to} className={className}>
            <Icon className="h-5 w-5" />
            <span>{tab.label}</span>
          </Link>
        );
      })}
    </nav>
  );
};

export default MobileTabBar;
